import emailIcon from 'public/static/images/email.svg';
import { useTranslation } from 'react-i18next';
import css from 'styled-jsx/css';
import ShareItem from './ShareItem';

interface EmailShareItemProps {
  url: string;
  shareText: string;
  shareSubject: string;
  onClick: () => void;
}

const emailIconCss = css.resolve`
  .email-icon {
    width: 28px;
    height: 21px;
    margin: 0;
  }
`;

function EmailShareItem({
  shareSubject,
  shareText,
  url,
  onClick,
}: EmailShareItemProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <ShareItem
      actionText={t('auth.common.email')}
      iconImage={emailIcon}
      linkUrl={`mailto:?subject=${shareSubject}&body=${shareText} ${url}`}
      onClick={onClick}
      iconClass={`email-icon ${emailIconCss.className}`}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      iconCss={emailIconCss}
    />
  );
}

export default EmailShareItem;
